import Vuex from 'vuex'

export default new Vuex.Store({
  state: {
    permissions: null,
    isLoading: false
  },
  mutations: {
    setPermissions (state, permissions) {
      state.permissions = JSON.parse(permissions)
    },
    setLoading (state, status) {
      state.isLoading = status
    }
  }
})
